"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _member_label = require("@/api/member/member_label.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MemberLabelCardPane',
  components: {},
  props: {
    fnId: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      memberLabel: {},
      memberList: [],
      checkedMemberList: [],
      total: 0,
      tableKey: 0,
      loading: false,
      listQuery: {
        page: 1,
        limit: 10,
        keywords: '',
        cursor: ''
      }
    };
  },
  created: function created() {
    this.getMemberLabel();
    this.getMemberComboPage();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(val) {
      this.checkedMemberList = val || [];
    },
    handleLabelBindMember: function handleLabelBindMember() {
      var _this = this;
      if (this.checkedMemberList.length === 0) {
        this.$message.warning('请选择要绑定的会员');
        return;
      }
      (0, _member_label.labelBindMember)({
        memberLabelFnId: this.fnId,
        memberFnIds: this.checkedMemberList.map(function (item) {
          return item.userFnId;
        })
      }).then(function () {
        _this.$message.success('绑定成功');
        _this.$emit('success');
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getMemberComboPage();
    },
    getMemberComboPage: function getMemberComboPage() {
      var _this2 = this;
      this.loading = true;
      (0, _member_label.queryMemberComboPage)(this.listQuery).then(function (res) {
        _this2.memberList = res.records || [];
        _this2.total = res.total || 0;
        _this2.listQuery.cursor = res.cursor || '';
        _this2.loading = false;
      }, function () {
        _this2.loading = false;
      });
    },
    getMemberLabel: function getMemberLabel() {
      var _this3 = this;
      (0, _member_label.queryMemberLabel)(this.fnId).then(function (res) {
        _this3.memberLabel = res.data || {};
      });
    }
  }
};